import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from 'primereact/dropdown'

import i18n from '../../../../../../utils/i18n'
import { EInvoiceTargetFormat } from '../../../data/model'
import { invoiceTypeBodyTemplate } from './invoiceTypeBodyTemplate'

export const invoiceTypeFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const status: EInvoiceTargetFormat[] = [
    EInvoiceTargetFormat.Request_for_payment,
    EInvoiceTargetFormat.Debit_note_related_to_goods_or_services,
    EInvoiceTargetFormat.Credit_note_related_to_goods_or_services,
    EInvoiceTargetFormat.Metered_services_invoice,
    EInvoiceTargetFormat.Credit_note_related_to_financial_adjustments,
    EInvoiceTargetFormat.Debit_note_related_to_financial_adjustments,
    EInvoiceTargetFormat.Tax_notification,
    EInvoiceTargetFormat.Invoicing_data_sheet,
    EInvoiceTargetFormat.Direct_payment_valuation,
    EInvoiceTargetFormat.Provisional_payment_valuation,
    EInvoiceTargetFormat.Payment_valuation,
    EInvoiceTargetFormat.Interim_application_for_payment,
    EInvoiceTargetFormat.Final_payment_request_based_on_completion_of_work,
    EInvoiceTargetFormat.Payment_request_for_completed_units,
    EInvoiceTargetFormat.Self_billed_credit_note,
    EInvoiceTargetFormat.Consolidated_credit_note_goods_and_services,
    EInvoiceTargetFormat.Price_variation_invoice,
    EInvoiceTargetFormat.Credit_note_for_price_variation,
    EInvoiceTargetFormat.Delcredere_credit_note,
    EInvoiceTargetFormat.Proforma_invoice,
    EInvoiceTargetFormat.Partial_invoice,
    EInvoiceTargetFormat.Commercial_invoice_which_includes_a_packing_list,
    EInvoiceTargetFormat.Commercial_invoice,
    EInvoiceTargetFormat.Credit_note,
    EInvoiceTargetFormat.Commission_note,
    EInvoiceTargetFormat.Debit_note,
    EInvoiceTargetFormat.Corrected_invoice,
    EInvoiceTargetFormat.Consolidated_invoice,
    EInvoiceTargetFormat.Prepayment_invoice,
    EInvoiceTargetFormat.Hire_invoice,
    EInvoiceTargetFormat.Tax_invoice,
    EInvoiceTargetFormat.Self_billed_invoice,
    EInvoiceTargetFormat.Delcredere_invoice,
    EInvoiceTargetFormat.Factored_invoice,
    EInvoiceTargetFormat.Lease_invoice,
    EInvoiceTargetFormat.Consignment_invoice,
    EInvoiceTargetFormat.Factored_credit_note,
    EInvoiceTargetFormat.Optical_Character_Reading_OCR_payment_credit_note,
    EInvoiceTargetFormat.Debit_advice,
    EInvoiceTargetFormat.Reversal_of_debit,
    EInvoiceTargetFormat.Reversal_of_credit,
    EInvoiceTargetFormat.Self_billed_debit_note,
    EInvoiceTargetFormat.Forwarders_credit_note,
    EInvoiceTargetFormat.Forwarders_invoice_discrepancy_report,
    EInvoiceTargetFormat.Insurers_invoice,
    EInvoiceTargetFormat.Forwarders_invoice,
    EInvoiceTargetFormat.Port_charges_documents,
    EInvoiceTargetFormat.Invoice_information_for_accounting_purposes,
    EInvoiceTargetFormat.Freight_invoice,
    EInvoiceTargetFormat.Claim_notification,
    EInvoiceTargetFormat.Consular_invoice,
    EInvoiceTargetFormat.Partial_construction_invoice,
    EInvoiceTargetFormat.Partial_final_construction_invoice,
    EInvoiceTargetFormat.Final_construction_invoice,
    EInvoiceTargetFormat.Customs_invoice,
  ]

  const valueTemplate = (option: any, props: DropdownProps) => {
    if (option !== null && option !== undefined) {
      return invoiceTypeBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return invoiceTypeBodyTemplate(option)
  }

  return (
    <Dropdown
      value={options.value}
      options={status}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t(
        'eInvoiceHistory.table.columns.invoiceType.filterPlaceholder',
      )}
    />
  )
}
